import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import RolesStore from '../../stores/RolesStore'
import LoadingWrapper from '../../components/LoadingWrapper'
import Toast from '../../components/Toast'
import { Button, Form, Grid, Table } from 'semantic-ui-react'
import Input from '../../components/Forms/Input'
import Checkbox from '../../components/Forms/Checkbox'

@withRouter
@observer
class RolesEditScreen extends Component {
  static propTypes = {
    match: PropTypes.object
  }

  constructor (props) {
    super(props)
    if (props.match.params.roleId) {
      window.document.title = 'Modifier le rôle'
    } else {
      window.document.title = 'Créer un rôle'
    }
    this.rolesStore = new RolesStore()
  }

  componentDidMount () {
    if (this.props.match.params.roleId) {
      this.rolesStore.loadOne(this.props.match.params.roleId)
    }
  }

  handleSaveRole = () => {
    this.rolesStore.save(this.props.match.params.roleId).then(result => {

    })
  }

  render () {
    const { isLoading, isSaving, toasts } = this.rolesStore
    return (
      <>
        <LoadingWrapper loading={isSaving} message='Sauvegarde en cours...' />
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Toast toasts={toasts} />
        <Form>
          <Grid columns='equal'>
            <Grid.Row>
              <Grid.Column>
                <Input name='role.name' store={this.rolesStore} label='Nom du role' />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Table celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>
                      Nom de la section
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Lecture tous
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Lecture limité
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Lecture propriétaire
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Création
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Modification
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      Supression
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>
                      Calendrier
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.0.read_all' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.0.read_limited' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.0.read_owner' />
                    </Table.Cell>
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Clients
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.1.read_all' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.1.read_limited' />
                    </Table.Cell>
                    <Table.Cell />
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.1.create' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.1.edit' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.1.delete' />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Inspections
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.2.read_all' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.2.read_limited' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.2.read_owner' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.2.create' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.2.edit' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.2.delete' />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Archives
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.3.read_all' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.3.read_limited' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.3.read_owner' />
                    </Table.Cell>
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.3.delete' />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Gestion des utilisateurs
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.4.read_all' />
                    </Table.Cell>
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.4.create' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.4.edit' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.4.delete' />
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Gestion des courriels
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.5.read_all' />
                    </Table.Cell>
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.5.edit' />
                    </Table.Cell>
                    <Table.Cell />
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Gestion des rôles
                    </Table.Cell>
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell />
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.6.create' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.6.edit' />
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox store={this.rolesStore} name='role.roles_actions.6.delete' />
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Button
                  content='Enregistrer'
                  primary
                  onClick={this.handleSaveRole}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </>
    )
  }
}

export default RolesEditScreen
